import React, { useContext } from "react";
import LeftProfile from "../components/others/LeftProfile";
import cv from "../assets/img/TamerlanFarajullayev.pdf"
import { Helmet } from "react-helmet";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";
const About = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <Helmet>
      <title>{t.about}</title>
    </Helmet>
      <section className="content-box-area mt-4">
        <div className="container">
          <div className="row g-4">
            <LeftProfile />
            <div className="col-xl-8">
              <div className="card content-box-card">
                <div className="card-body">
                  <div className="top-info">
                    <div className="text">
                      <h1 className="main-title" dangerouslySetInnerHTML={{__html:t.hi}}/> 
                      <p>
                        <b>Front-end Developer</b> 🖥️ &amp;{" "}

                      </p>
                    </div>
                    <div className="available-btn">
                      <span>
                        <i className="fas fa-circle" /> {t.freelance}
                      </span>
                    </div>
                  </div>
                  <div className="counter-area">
                    <div className="counter">
                      <div className="counter-item">
                        <h3 className="number">2+</h3>
                        <p className="subtitle">{t.year}</p>
                      </div>
                      <div className="counter-item">
                        <h3 className="number">10+</h3>
                        <p className="subtitle">{t.completed}</p>
                      </div>
                      <div className="counter-item">
                        <h3 className="number">50+</h3>
                        <p className="subtitle">{t.happy}</p>
                      </div>
                    </div>
                    <div className="circle-area">
                      <div className="circle-text">
                        <img
                          className="circle-image"
                          src="assets/img/about-us/circle-text.svg"
                          alt="circle-text"
                        />
                        <img
                          className="circle-image circle-image-light d-none"
                          src="assets/img/about-us/circle-text-light.svg"
                          alt="circle-text"
                        />
                        <span className="arrow-down">
                          <svg
                            width={40}
                            height={40}
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 5V35"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M15 30L20 35L25 30"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="working-with-area">
                    <h2 className="main-common-title">{t.who} ✨</h2>
                    <p dangerouslySetInnerHTML={{__html:t.aboutme}}/>
                    <a href={cv} download="TamerlanFarajullayev" className="bg-primary p-3 mt-4 text-white" style={{borderRadius:"15px"}}>
                  {t.download} ✨
                    </a>
                  </div>
                  <div className="work-together-slider">
                    <div className="slider-main d-flex gap-4 align-items-center">
                      <div className="slider-item">
                        <a href="#">{t.lets}</a>
                        <a href="#">{t.lets}</a>
                      </div>
                      <div className="slider-item">
                        <a href="#">{t.lets}</a>
                        <a href="#">{t.lets}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
